import React from 'react';

import styles from './Loader.module.scss';

const animation = require('./imgs/loader.mp4');

const Loader = () => (
  <div className={styles.loaderWrapper}>
    <div className={styles.loaderContainer}>
      <video
        autoPlay
        muted
        playsInline
        loop
      >
        <source src={animation} type="video/mp4" />
      </video>
    </div>
  </div>
);

export default Loader;
